import { MERCHANT_OPERATIONS } from "@price-rescue/api-contracts";

import type { MerchantApiClient } from "../../types.js";
import type { MerchantBootstrapResponse } from "./models.js";

interface DataEnvelope<T> {
  data: T;
}

export interface MerchantAuthenticationApi {
  bootstrapSession(): Promise<MerchantBootstrapResponse>;
}

export function createMerchantAuthenticationApi(
  client: MerchantApiClient,
): MerchantAuthenticationApi {
  return {
    async bootstrapSession() {
      const envelope = await client.operation<DataEnvelope<MerchantBootstrapResponse>>(
        MERCHANT_OPERATIONS.bootstrapShopifySession,
        {
          request: { requiresFreshToken: true },
        },
      );
      return envelope.data;
    },
  };
}
